import { getRequest, postRequest, patchRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

export const getGolfActiveTournament = async () => {
  try {
    const { response, logComplete } = await getRequest('golfActiveTournament')
    logComplete()
    return response
  } catch (error) {
    logger.error('getGolfActiveTournament', error)
    return null
  }
}

export const getGolfEligiblePlayers = async () => {
  try {
    const { response, logComplete } = await getRequest('golfEligiblePlayers')
    logComplete()
    return response
  } catch (error) {
    logger.error('getGolfEligiblePlayers', error)
    return []
  }
}

export const postGolfPicks = async (tournamentKey, picks) => {
  const data = { tournamentKey, picks }
  try {
    const { response, logComplete } = await postRequest('golfPicks', data)
    logComplete()
    return response
  } catch (error) {
    logger.error('postGolfPicks', error)
    throw error
  }
}

export const getGolfPicks = async (tournamentKey) => {
  const params = { tournamentKey }
  try {
    const { response, logComplete } = await getRequest('golfPicks', params)
    logComplete()
    return response
  } catch (error) {
    logger.error('getGolfPicks', error)
    return null
  }
}

export const getGolfLeaderboard = async (tournamentKey) => {
  const params = { tournamentKey }
  try {
    const { response, logComplete } = await getRequest('golfLeaderboard', params)
    logComplete()
    return response
  } catch (error) {
    logger.error('getGolfLeaderboard', error)
    return null
  }
}

export const getGolfTournaments = async () => {
  try {
    const { response, logComplete } = await getRequest('golfTournaments')
    logComplete()
    return response
  } catch (error) {
    logger.error('getGolfTournaments', error)
    return null
  }
}

// Add these to golfService.js

export const postGolfPool = async (poolData) => {
  try {
    const { response, logComplete } = await postRequest('golfPool', poolData)
    logComplete()
    return response
  } catch (error) {
    logger.error('postGolfPool', error)
    throw error
  }
}

export const getGolfPool = async (tournamentKey) => {
  try {
    const { response, logComplete } = await getRequest('golfPool', { tournamentKey })
    logComplete()
    return response
  } catch (error) {
    logger.error('getGolfPool', error)
    return null
  }
}

export const getGolfPoolsPublic = async (tournamentKey) => {
  try {
    const { response, logComplete } = await getRequest('golfPoolsPublic', { tournamentKey })
    logComplete()
    return response
  } catch (error) {
    logger.error('getGolfPoolsPublic', error)
    return null
  }
}

export const postGolfPoolJoin = async (poolId, inviteKey) => {
  try {
    const { response, logComplete } = await postRequest('golfPoolJoin', { poolId, inviteKey })
    logComplete()
    return response
  } catch (error) {
    logger.error('postGolfPoolJoin', error)
    throw error
  }
}

export const getGolfPoolLeaderboard = async (poolId) => {
  try {
    const { response, logComplete } = await getRequest('golfPoolLeaderboard', { poolId })
    logComplete()
    return response
  } catch (error) {
    logger.error('getGolfPoolLeaderboard', error)
    return null
  }
}

export const getGolfPoolPendingMembers = async (poolId) => {
  try {
    const { response, logComplete } = await getRequest('golfPoolPendingMembers', { poolId })
    logComplete()
    return response
  } catch (error) {
    logger.error('getGolfPoolPendingMembers', error)
    return null
  }
}

export const approveGolfPoolMember = async (poolId, memberUid) => {
  try {
    const { response, logComplete } = await patchRequest('golfPoolApprove', { poolId, memberUid })
    logComplete()
    return response
  } catch (error) {
    logger.error('approveGolfPoolMember', error)
    throw error
  }
}

export const denyGolfPoolMember = async (poolId, memberUid) => {
  try {
    const { response, logComplete } = await patchRequest('golfPoolDeny', { poolId, memberUid })
    logComplete()
    return response
  } catch (error) {
    logger.error('denyGolfPoolMember', error)
    throw error
  }
}
